// Maps Discord roles to their Discord role id.
enum DiscordRoleId {
  VerifiedArtist = "930231015241285692",
}

export default DiscordRoleId;
